import { inject, Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { map } from 'rxjs/operators';

import { RentDepositModel } from '@ui/shared/model';

import { RentedPropertyMatchesStore } from '@ui/tenant-pool/shared/property-matches/data-access';
import {
  depositInfoQuery,
  DepositInfoResponse,
  useRuvDepositMutation,
  UseRuvDepositResponse
} from '../queries/rental-deposit.queries';

@Injectable({
  providedIn: 'root'
})
export class RentalDepositFacade {
  private apollo = inject(Apollo);
  private rentedStore = inject(RentedPropertyMatchesStore);

  public loadDepositInfo(propertyId: string) {
    return this.apollo
      .query<DepositInfoResponse>({
        query: depositInfoQuery,
        variables: {
          propertyId
        },
        fetchPolicy: 'no-cache'
      })
      .pipe(map(response => response.data.depositInfo));
  }

  public useRuvDeposit(propertyId: string, input: RentDepositModel) {
    return this.apollo
      .mutate<UseRuvDepositResponse>({
        mutation: useRuvDepositMutation,
        variables: {
          propertyId,
          input
        },
        update: () => this.rentedStore.reload()
      })
      .pipe(map(response => response.data.useRuvDeposit));
  }
}
